var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 .188c-11.028 0-20 8.972-20 20 0 11.027 8.972 20 20 20 11.027 0 20-8.973 20-20 0-11.028-8.971-20-20-20zm4.974 20.704H21.72v11.597h-4.822V20.892h-2.292v-4.1h2.292v-2.65c0-1.9.903-4.866 4.866-4.866l3.573.013v3.98h-2.593c-.422 0-1.022.21-1.022 1.116v2.408h3.673l-.421 4.099z","fill":"#FFF","fillRule":"nonzero"}));
}

Facebook.defaultProps = {"viewBox":"0 0 42 42"};

module.exports = Facebook;

Facebook.default = Facebook;
